/*
 * DRIVLY-UI React Components
 * @license MIT
 */
import{createContext as t}from"react";const o=t({transformPagePoint:t=>t,isStatic:!1,reducedMotion:"never"});export{o as MotionConfigContext};
//# sourceMappingURL=MotionConfigContext.js.map
